import axios from 'axios'
import {
	Message
} from 'element-ui'
import { getUserToken, getStaffToken, getCurrentRole, removeStaffToken } from '@/utils/auth'
import { getApiBaseUrl } from '@/utils/image'

const instance = axios.create({
	baseURL: getApiBaseUrl(),
	timeout: 10000
})

instance.interceptors.request.use(config => {
	const role = getCurrentRole()

	if (role === 'staff') {
		config.headers['token'] = getStaffToken()
	} else {
		config.headers['token'] = getUserToken()
	}

	console.log(`[API Request] ${config.method.toUpperCase()} ${config.baseURL}${config.url}`, config.params ||
	config.data || '')
	return config
})

instance.interceptors.response.use(
	response => {
		const res = response.data
		console.log(`[API Response]`, res)

		if (res.status === -9999) {
			const role = getCurrentRole()
			if (role === 'staff') {
				removeStaffToken()
				window.location.href = '/#/yewuduan/login'
			} else {
				localStorage.removeItem('mcexchange_token')
				localStorage.removeItem('mcexchange_userinfo')
				window.location.href = '/#/login'
			}
			return Promise.reject(new Error('登录失效'))
		}

		if (res.status === 0) {
			const role = getCurrentRole()
			if (role === 'staff' && (res.msg.includes('登录已过期') || res.msg.includes('请重新登录'))) {
				removeStaffToken()
				window.location.href = '/#/yewuduan/login'
			}
			return Promise.reject(new Error(res.msg))
		}

		// 业务状态码（如 -2 已核销等）直接透传给调用方处理，不视为错误
		return res
	},
	error => {
		console.error('[API Error]', error)
		if (error.message.includes('timeout')) {
			Message.error('请求超时，请稍后重试')
		} else {
			Message.error('网络错误，请检查网络连接')
		}
		return Promise.reject(error)
	}
)

export default instance